export default class AccountService {
  static getMainAccount(accounts) {
    return accounts ? accounts.find(x => x.isMain) : null;
  }
}
